<template>
	<div style="background-color: #fff;min-height: 100vh;padding: 1vh 1vw;">
		<!--头部-->
		<div style="text-align: left;">
			<el-form :inline="true" :model="queryForm">
				<!-- <el-form-item>
					<el-input v-model="queryForm.user" placeholder="客户电话"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">查询</el-button>
				</el-form-item> -->
				<el-form-item>
					<el-button @click="createWindow=true" type="primary">新增客户</el-button>
				</el-form-item>
			</el-form>
			<div style="float: right;margin: 1vh 2vw 2vh 2vw;">
			</div>
		</div>
		<!--创建客户弹窗-->
		<div>
			<el-dialog title="创建客户" v-model="createWindow" width="40%" :destroy-on-close="true"
				:close-on-press-escape="false" :close-on-click-modal="false">
				<div style="margin: 0 10%;">
					<el-form ref="form" label-position="left" label-width="6em" :model="createForm">
						<el-form-item label="客户名称">
							<el-input style="width: 100%;" v-model="createForm['customerName']"
								placeholder="客户名称"></el-input>
						</el-form-item>
						<el-form-item label="客户电话">
							<el-input style="width: 100%;" v-model="createForm['customerPhone']"
								placeholder="客户电话"></el-input>
						</el-form-item>
						<el-form-item label="业务员名称">
							<el-input style="width: 100%;" v-model="createForm['courierName']"
								placeholder="业务员名称"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input type="textarea" style="width: 100%;" v-model="createForm['remark']"
								placeholder="备注"></el-input>
						</el-form-item>
						<el-form-item style="margin-top: 6vh;">
							<el-button type="primary" @click="createCustomer(createForm)">提交</el-button>
							<el-button @click="createWindow=false">取消</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-dialog>
		</div>
		<!--客户展示列表-->
		<div style="margin-top: 2vh;">
			<el-table :data="customerList" style="width: 100%"
				:header-cell-style="{background:'#eceff4',color:'#7f7f7f','font-weight': 500,'font-family': 'sans-serif','color': '#000'}">
				<el-table-column prop="customerName" label="客户名称" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="customerPhone" label="客户电话" header-align="center"
					align="center"></el-table-column>
				<el-table-column prop="courierName" label="业务员" header-align="center" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
				<el-table-column prop="creationTime" label="创建时间" header-align="center"
					align="center"></el-table-column>
				<el-table-column label="操作" header-align="center" align="center">
					<template #scope>
						<!-- <el-button type="text" @click="open(scope.row)">编辑</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				customerList: [],
				queryForm: {
					a: ""
				},
				createForm: {

				},
				createWindow: false
			}
		},
		methods: {
			createCustomer(createForm) {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "createCustomer",
						content: createForm
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.createWindow = false;
							this.getCustomerList();
						}
					})
					.finally(() => {
						loading.close();
					})
			},
			getCustomerList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "getCustomerList",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.customerList = res.data.customerList;
						}
					})
					.finally(() => {
						loading.close();
					})
			}
		},
		mounted() {
			this.getCustomerList()
		}
	}
</script>

<style scoped>

</style>